import { memo } from 'react'
import styled from 'styled-components'
import { ErrorMessage, ErrorMessageProps } from 'formik'

import { colors } from '@/styles'

export const ErrorText = styled.p`
  color: ${colors.pink};
  font-size: 11px;
  padding-left: 6px;
  line-height: 18px;
  margin: 0;
  width: 100%;
`

type Props = ErrorMessageProps

const Error: React.FC<Props> = ({ name, ...rest }) => (
  <ErrorMessage
    {...rest}
    name={name}
    render={msg => (
      <ErrorText
        data-testid={`errors-${name}`}
        id={`${name}-message`}
        role="alert"
        aria-label={msg}
      >
        {`${msg.charAt(0).toUpperCase()}${msg.slice(1)}`}
      </ErrorText>
    )}
  />
)

export default memo(Error)
